
// this key is used by biometricAuth to keep track of user's setup status
export const BiometricAuthCredsStoredKey = "BiometricAuthCredsStoredKey";

export const persistedKeys = [BiometricAuthCredsStoredKey];